import { render, staticRenderFns } from "./CustomerGiftCard.vue?vue&type=template&id=556be53a&"
import script from "./CustomerGiftCard.vue?vue&type=script&lang=js&"
export * from "./CustomerGiftCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports